import BaseTibbit from '@appblocks/codegeneration/Tibbits/_BaseTibbit';
import Tibbits from '@appblocks/codegeneration/Tibbits/index';
import {
    CodeBlock, BlockType, SettingType, TibboDataType,
    ValidationMessage, ValidationMessageType, IOMode,
} from '@appblocks/codegeneration/types';
import IOTibbit from '@appblocks/codegeneration/Tibbits/_IOTibbit';

export default class Tibbit_03_2 extends IOTibbit {
    constructor() {
        super();
        this.id = 'tibbit_03_2';
        this.name = 'Tibbit 03_2';
        this.lines = 2;
        this.mode = IOMode.OUTPUT;
        this.initLines();
    }
}
